module.exports = __webpack_public_path__ + "img/vertical_3_4_8004.b4e5b6d8.png";